const locales = [
  'es-AR',
  'es-CL',
  'es-EC',
  'es-PY',
  'es-US',
  'pt-BR',
  'es-CO',
  'es-GT',
  'es-PE',
  'es-UY',
  'en-US',
  'es-DO',
  'es-PA',
  'fr-CA',
  'es-PR',
  'es-MX',
  'es-CR',
  'en-AU',
  'id-ID',
  'vi-VN',
  'zh-CN',
  'ja-JP',
  'th-TH',
  'ko-KR',
  'sq-AL',
  'bg-BG',
  'da-DK',
  'ka-GE',
  'is-IS',
  'lv-LV',
  'nl-NL',
  'ro-RO',
  'de-CH',
  'en-GB',
  'hy-AM',
  'nl-BE',
  'hr-HR',
  'et-EE',
  'de-DE',
  'lt-LT',
  'ro-MD',
  'no-NO',
  'ru-RU',
  'it-CH',
  'de-AT',
  'fr-BE',
  'fi-FI',
  'el-GR',
  'it-IT',
  'fr-LU',
  'ru-MD',
  'pl-PL',
  'sv-SE',
  'az-AZ',
  'cs-CZ',
  'fr-FR',
  'hu-HU',
  'mk-MK',
  'pt-PT',
  'sk-SK',
  'fr-CH',
  'uk-UA',
  'sl-SI',
  'en-IE',
  'es-ES',
  // 'sr-Latn-RS', // some issues with volvocm
  'tr-TR',
  'bs-BA',
  'sq-XK',
  'ar-OM',
  'ar-SA',
  'ar-AE',
  'ar-BH',
  'fr-TN',
  'ar-JO',
  'ar-QA',
  'ar-EG',
  'ar-KW',
  'he-IL',
  'fr-MA',
  'pt-AO',
  'zh-TW',
];

const languageToLocale = {
  es: 'es-ES',
  pt: 'pt-PT',
  en: 'en-GB',
  fr: 'fr-FR',
  zh: 'zh-CN',
  nl: 'nl-NL',
  de: 'de-DE',
  it: 'it-IT',
  ru: 'ru-RU',
  ro: 'ro-RO',
  ar: 'ar-AE',
  sq: 'sq-AL',
};

module.exports = {
  locales,
  languageToLocale,
};
